module.exports = __webpack_public_path__ + "static/media/m4.08891200.jpg";